import { execute } from 'utils/API';
import { apiEndoints, httpMethods } from 'utils/constants';
import PropTypes from 'prop-types';

const getFileReview = ({ queryKey }) => {
  return execute(
    httpMethods.GET,
    `${apiEndoints.LIST_FILES}/${queryKey[2]}`,
    { authorization: queryKey[1] },
    {},
    10,
  );
};

getFileReview.propTypes = {
  queryKey: PropTypes.array.isRequired,
};

export { getFileReview };
